function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_18199",
  "data-name": "Path 18199",
  d: "M21.661,11.239a3.644,3.644,0,0,0-6.312,0L5.508,28.284a3.644,3.644,0,0,0,3.156,5.466H28.346A3.644,3.644,0,0,0,31.5,28.284ZM18.5,30.8a1.406,1.406,0,1,1,1.406-1.406A1.406,1.406,0,0,1,18.5,30.8Zm1.985-14.1-.5,8.44a1.491,1.491,0,0,1-2.976,0l-.5-8.44a1.988,1.988,0,1,1,3.969,0Z",
  transform: "translate(-5.02 -9.417)",
  fill: "#e36767"
});
const SvgWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.97,
    height: 24.333,
    viewBox: "0 0 26.97 24.333",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Warning.491844fb.svg";
export { ForwardRef as ReactComponent };